import { Link } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import { useTheme } from '../contexts/ThemeContext';
import LanguageSelector from './LanguageSelector';

function Footer() {
  const year = new Date().getFullYear();
  const { t } = useLanguage();
  const { theme } = useTheme();

  const footerLogoSrc = theme === 'light'
    ? 'https://res.cloudinary.com/dgggdig3s/image/upload/f_auto,q_auto/BLogo_black_nobackground_u9c62d.png'
    : 'https://res.cloudinary.com/dgggdig3s/image/upload/f_auto,q_auto/BLogo_white_nobackground_ehgnnn.png';

  return (
    <footer className="footer">
      <div className="footer-wave" aria-hidden />
      <div className="footer-inner">
        <div className="footer-block footer-block--brand">
          <div className="footer-brand-wrap">
            <img src={footerLogoSrc} alt="" className="footer-logo" />
            <div className="footer-brand-texts">
              <h3 className="footer-brand">Brundin Gestión S.L.</h3>
              <p className="footer-tagline">{t('footer.tagline')}</p>
            </div>
          </div>
        </div>
        <div className="footer-block footer-block--links">
          <h4 className="footer-heading">{t('footer.linksHeading')}</h4>
          <ul className="footer-links">
            <li><Link to="/">{t('footer.home')}</Link></li>
            <li><Link to="/contacto">{t('footer.contact')}</Link></li>
            <li><Link to="/locales">{t('footer.locales')}</Link></li>
            <li><Link to="/faqs">{t('footer.faqs')}</Link></li>
            <li><Link to="/terminos">{t('footer.terms')}</Link></li>
            <li><Link to="/proteccion-datos">{t('footer.privacy')}</Link></li>
          </ul>
        </div>
        <div className="footer-block footer-block--contact">
          <h4 className="footer-heading">{t('footer.contactHeading')}</h4>
          <ul className="footer-contact">
            <li><a href="tel:+34654866634">+34 654 86 66 34</a></li>
            <li><a href="tel:+34661690597">+34 661 69 05 97</a></li>
            <li><a href="mailto:admin@brundingestion.com">admin@brundingestion.com</a></li>
          </ul>
        </div>
        <div className="footer-block footer-block--lang">
          <h4 className="footer-heading">{t('footer.languageHeading')}</h4>
          <LanguageSelector />
        </div>
      </div>
      <div className="footer-bottom">
        <p className="footer-copy">© {year} Brundin Gestión S.L. · {t('footer.copy')}</p>
        <p className="footer-brundindev">{"</>"} {t('footer.madeBy')} <a href="https://brundindev-portfolio.vercel.app" target="_blank" rel="noopener noreferrer" className="footer-brundindev-link">@brundindev</a></p>
      </div>
    </footer>
  );
}

export default Footer;
